import { render } from "./FullBalanceView.vue?vue&type=template&id=49723a2e&scoped=true"
import script from "./FullBalanceView.vue?vue&type=script&lang=js"
export * from "./FullBalanceView.vue?vue&type=script&lang=js"

import "./FullBalanceView.vue?vue&type=style&index=0&id=49723a2e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49723a2e"]])

export default __exports__